import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'HourPicker',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    width: {
      type: String,
      default:''
    },
    disabled: {
      type: Boolean,
      required:false,
      default:false
    },
    inputError: {
      type: Boolean,
      required: false,
      default: false,
    },
    minHour: {
      type: Number,
      required: false,
      default: 0,
    },
    maxHour: {
      type: Number,
      required: false,
      default: 23,
    },
    icon: {
      type: String,
      required: false,
      default: 'pi pi-clock',
    }
  },
  emits: ['update:modelValue'],
})
export default class HourPicker extends Vue {
  disabled!: boolean;
  width!: string
  modelValue!: number;
  inputError!: boolean;
  minHour!: number;
  maxHour!: number;
  icon!: string;

  addHour() {
    let newModelValue = this.modelValue;
    if (this.modelValue < this.maxHour) {
      newModelValue = this.modelValue +1 
    }
    this.$emit('update:modelValue', newModelValue);
  }

  removeHour() {
    let newModelValue = this.modelValue
    if (this.modelValue > this.minHour) {
      newModelValue = this.modelValue -1 
    }
    this.$emit('update:modelValue', newModelValue);
  }

  get textToShow() {
    return `${this.modelValue.toString().padStart(2, '0')}:00`;
  }
}
